/**
 * jai1 settings get <key> [-j]
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { SettingsService } from '../../services/settings.service.js';
import type { SettingsGetOptions } from '../../types/settings.types.js';

export function createSettingsGetCommand(): Command {
    return new Command('get')
        .description('Get a setting value (dot-notation)')
        .argument('<key>', 'Setting key (e.g., tasks.cloud)')
        .option('-j, --json', 'Output JSON')
        .action(async (key: string, options: SettingsGetOptions) => {
            try {
                const service = new SettingsService();
                const value = service.get(key);

                if (options.json) {
                    console.log(JSON.stringify({ key, value }));
                    return;
                }

                if (value === undefined) {
                    console.log(chalk.dim(`${key} is not set`));
                } else {
                    console.log(`${chalk.cyan(key)} = ${JSON.stringify(value)}`);
                }
            } catch (error) {
                if (options.json) {
                    console.log(JSON.stringify({ error: error instanceof Error ? error.message : String(error) }));
                } else {
                    console.error(chalk.red(`❌ ${error instanceof Error ? error.message : String(error)}`));
                }
                process.exit(1);
            }
        });
}
